import React from 'react';

interface CodeProps {
  value: { language: string; code: string };
}

export const CodeTypesBlock = ({ value: { language, code } }: CodeProps) => (
  <pre data-language={language}>
    <code>{code}</code>
  </pre>
);
